import { memo } from "react";

import { t } from "@/i18n-js/instance";
import { StatusBadge } from "@/react/components/SettingsApp/CompassCompat/StatusBadge";
import { Radio } from "@/react/components/shared/uikit/Radio";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { annualDiscountPercentage } from "@/react/helpers/planHelpers";

import type { RadioOptionProps } from "./types";

export const AnnualRadioOption = memo<RadioOptionProps>(
  ({ id, interval, isSelected, onIntervalChange, plan }) => (
    <Radio
      id={id}
      name="billing-interval"
      label={
        <div className="flex flex-row items-center gap-2">
          <Typography.LabelSm weight="semibold">
            {t("pricing_plans.plan_settings.plan_summary.annual_billing")}
          </Typography.LabelSm>
          {plan && (
            <StatusBadge variant="success">
              {t("pricing_plans.plan_settings.plan_summary.annual_savings", {
                percentage: annualDiscountPercentage(plan),
              })}
            </StatusBadge>
          )}
        </div>
      }
      value={interval}
      description={
        <Typography.BodySm weight="normal">
          {t("pricing_plans.plan_settings.plan_summary.plan_annual_amount", {
            amount: plan?.display_base_monthly_amount,
          })}
        </Typography.BodySm>
      }
      defaultChecked={isSelected}
      onChange={() => onIntervalChange(interval)}
    />
  ),
);

AnnualRadioOption.displayName = "AnnualRadioOption";
